import { useState } from 'react';

import { SummaryGraph } from '~widgets/summary-graph';
import { SummaryTable } from '~widgets/summary-table';

import { Filters, type FiltersValue } from '~features/dashboard-filters';

import { Container } from '~shared/ui/layout';
import { Loader } from '~shared/ui/loader';

import { filtersToParams } from '../lib';

export const DashboardPage = () => {
  const [filters, setFilters] = useState<FiltersValue>();
  return (
    <Container>
      <div className="box-border min-h-full w-full pt-10 pb-16">
        <h2 className="mt-0 mb-10 text-4xl font-bold">Dashboard</h2>
        <div className="rounded-[16px] bg-white px-5 pt-5">
          <Filters screen="dashboard" onFiltersChange={setFilters} />
        </div>
        <div
          className={`
            relative mt-5 flex min-h-[600px] flex-col rounded-[16px] bg-white
            p-5
          `}
        >
          {filters ? (
            <>
              <SummaryGraph filters={filtersToParams(filters)} />
              <SummaryTable filters={filtersToParams(filters)} />
            </>
          ) : (
            <Loader />
          )}
        </div>
      </div>
    </Container>
  );
};
